var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesProfessionals({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "10 10 180 180",
    viewBox: "10 10 180 180",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.783 190v-43.043a3.913 3.913 0 0 0-3.913-3.913H29.565a3.913 3.913 0 0 0-3.913 3.913V190h7.826v-39.13h23.478V190h7.827zM119.565 190v-74.348a3.913 3.913 0 0 0-3.913-3.913H84.348a3.913 3.913 0 0 0-3.913 3.913V190h7.826v-70.435h23.478V190h7.826zM126.077 42.087l7.043 16.435 7.043-3.13-12.522-28.957-28.955 12.521 3.13 7.043 16.435-7.043c-9.391 21.13-21.913 38.348-38.348 52.435-10.957 9.391-23.478 16.435-35.217 21.913L32.947 118c-2.348.783-3.13.783-3.913 1.565l-3.913.783 1.565 7.826 3.913-.783c.783 0 2.348-.783 4.696-1.565 3.913-1.565 7.826-2.348 12.522-4.696 12.522-5.478 25.826-13.304 37.565-23.478 17.217-14.869 30.521-32.869 40.695-55.565zM174.348 190V76.522a3.913 3.913 0 0 0-3.913-3.913H139.13a3.913 3.913 0 0 0-3.913 3.913V190h7.826V80.435h23.478V190h7.827z",
    fill: "#ffffff",
    "data-color": 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M190 182.174V190H10v-7.826h180zM56.957 65.565c3.913-.783 7.826-3.13 9.391-7.043 3.913-8.609 0-14.087-8.609-18.783-.783-.783-.783 0-3.913-1.565s-3.13-1.565-3.913-2.348c-4.696-2.348-6.261-4.696-4.696-7.826 2.348-3.913 10.957-3.913 14.087-1.565l3.13 2.348 4.696-6.261L64 19.391l-7.043-2.348V10H49.13v7.043c-4.696.783-8.609 3.13-10.957 7.826-3.913 8.609 0 14.087 8.609 18.783 1.565.783.783.783 3.913 2.348s3.13 1.565 3.913 1.565c5.478 2.348 6.261 4.696 4.696 7.826-1.565 3.913-10.957 3.913-14.087 1.565l-3.13-2.348-4.696 6.261 3.13 2.348c2.348 1.565 5.478 2.348 8.609 3.13v6.261h7.826v-7.043z",
    "data-color": 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesProfessionals);
export default __webpack_public_path__ + "static/media/sales_professionals.5f47fe90b41b82d438b078c3f67a799e.svg";
export { ForwardRef as ReactComponent };